import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {ApiService} from '@modules/api-service';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '@modules/constants-enumerate';
import translations from '@modules/i18n';

/**
 * @summary ProductCardInfo
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('product-card-info')
class ProductCardInfo extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ProductCardInfo.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'product-card-info';

  @property({type: Object})
  product = {};

  @property({type: Object})
  student = {};

  @property({type: String})
  ['user-type'] = 'student';

  @property({type: Object})
  passcodeInfo = {};

  async connectedCallback() {
    super.connectedCallback();

    this.passcodeInfo = await ApiService.abcmouseGetPasscodeInfo();
  }

  async invite() {
    const state = storeInstance.getState();
    await ApiService.sendInvites({
      student_ids: [state[sdoNs.STUDENT_INFO].id]
    });
    const studentInfo = await ApiService.studentGet(parseInt(state[sdoNs.STUDENT_INFO].id, 10));
    storeInstance.commit({namespace: sdoNs.STUDENT_INFO, mutationId: 'setData', payload: studentInfo});
  }

  async clearABCmousePassCode() {
    const payload = await ApiService.studentGet(this.student.id);
    storeInstance.commit({namespace: sdoNs.STUDENT_INFO, mutationId: 'setData', payload});
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default ProductCardInfo;
